import { useEffect, useState } from "react";
import MainLayout from "../components/layout/MainLayout";
import EventListForPendingVendor from "../components/page-components/events/EventListForPendingVendor";
import EventList from "../components/page-components/events/EventList";
import LegacyEventList from "../components/page-components/events/LegacyEventList";
import DashBoardHead from "../components/page-components/dashboard/DashBoardHead";
import Head from "next/head";
import { fetchPage } from "../services/useFetch";
import { pageFilter, fetchPageData } from "../services/cms/pages";
import { calculateDashboard } from "../services/calculateDashboard";
import { fetchNoStore, setNoStoreResponseHeaders } from "../services/ssrFetch";
import UpdateHeaderBannerContext from "../services/UpdateHeaderBannerContext";
import { transformIncomingData } from "../services/transformIncomingData";
import { applicationSafetyCheck } from "../services/cms/applicationSafetyCheck";
import { Typography } from "@mui/material";
import { GoogleAnalytics } from "@next/third-parties/google";
import Spinner from "../components/page-components/Spinner";

const Dashboard = ({
  // bannerData,
  userData,
  pageData,
  eventData,
  venueData,
}) => {
  const [calculatedData, setCalculatedData] = useState();
  const [accountStatus, setAccountStatus] = useState(false);
  const [publishedEvents, setPublishedEvents] = useState();
  const [applications, setApplications] = useState();
  const [serviceBasedUser, setServiceBasedUser] = useState(userData?.service_based_vendor);
  const [appliedEvents, setAppliedEvents] = useState();
  const [safety, setSafety] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userData) {
      if (
        userData.account_status === "approved" ||
        userData.legacy_status === "approved"
      ) {
        setAccountStatus(true);
      }
    }
  }, [userData]);

  const afterCalculatingData = async () => {
    const calculated = await calculateDashboard(userData /*session?.token*/);
    setCalculatedData(calculated);
  };

  const filterEventsForPublished = (eventData) => {
    const filteredEvents = [];
    if (eventData) {
      for (const item of eventData) {
        if (item.publish_status === "published" && item.legacy === false && serviceBasedUser === true && item.is_service_based === true) {
          filteredEvents.push(item);
        }
        else if (item.publish_status === "published" && item.legacy === false && serviceBasedUser === false) {
          filteredEvents.push(item);
        }
      }
    
      setPublishedEvents(filteredEvents);
    }
  };

  const safetyCheck = async () => {
    setIsLoading(true);
    const response = await applicationSafetyCheck();
    const appEvents = [];

    let check;
    if (response.status === 200) {
      check = await response.json();
    }

    // const event_id = event?.event_id;
    var appList = [];

    
    for (const item of check?.events_applications ?? []) {
      appEvents.push(check);
      for (const event of eventData) {
        if (item === event.id.toString()) {
          setSafety(safety => [...safety, event.id.toString()]);
          appList.push(
            {
            "app_id": check?.application_list.shift(),
            "event_id": event.id.toString()
          });
        }
      }
    }
    setAppliedEvents(appEvents[0]);
    setApplications(appList);
    setIsLoading(false);
  };

  useEffect(async () => {
    afterCalculatingData();
    safetyCheck();

    filterEventsForPublished(eventData);
  }, [userData, eventData]);

  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Dashboard</title>
        <meta name="description" content="a list of events" />
        <meta name="author" content="Boho" />
        <meta name="copyright" content="boho" />
        <meta name="robots" content="index, follow" />
        <meta name="rating" content="14 years" />
      </Head>
      <GoogleAnalytics gaId="G-D0JT6CYT2W" />
      <UpdateHeaderBannerContext />
      <DashBoardHead
        pageData={pageData}
        userData={userData}
        calculatedData={calculatedData}
        paymentInfo={appliedEvents}
      >
        {publishedEvents?.length === 0 && !userData?.service_based_vendor && (
          // <Typography variant="h6">
          //   Hi, Boho Community! Check back at the end of January as we start to
          //   add events to our {new Date().getFullYear()} schedule. Please email
          //   info@thebohomarket.com if you have any questions.
          // </Typography>
          <Typography variant="h6">
            Hi, Boho Community! We will be opening event applications on January 15th, 2025. Please email info@thebohomarket.com if you have any
            questions.
          </Typography>
        )}

        {publishedEvents?.length === 0 && userData?.service_based_vendor && (
          // <Typography variant="h6">
          //   Hi, Boho Community! Check back at the end of January as we start to
          //   add events to our {new Date().getFullYear()} schedule. Please email
          //   info@thebohomarket.com if you have any questions.
          // </Typography>
          <Typography variant="h6">
            Currently, we don't have any events open for service-based vendors. 
            Please check back, as we're always adding new events! Don't forget to 
            stay in the loop by joining our <a href="https://thebohomarket.us13.list-manage.com/subscribe?u=2e1d717888698433ec069f4cd&id=3410c0bb37">newsletter</a> and
             following us on <a href="https://www.instagram.com/thebohomarket/">Instagram</a>, <a href="https://www.facebook.com/thebohomarketplace">Facebook</a>,  
            and <a href="https://www.tiktok.com/@thebohomarket">TikTok</a>. 
            If you need further assistance, don't hesitate to email us at info@thebohomarket.com.
          </Typography>
        )}
        {publishedEvents?.length > 0 && !isLoading &&
         ( <EventList
            venueData={venueData}
            events={publishedEvents?.slice(0, 3)}
            safety={safety}
            appList={applications}
          />)
 }

        {isLoading ? <Spinner /> : <></>}
      </DashBoardHead>
    </>
  );
};

export default Dashboard;

Dashboard.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>;
};

export async function getServerSideProps({ req, res }) {
  setNoStoreResponseHeaders(res);

  const { cookies } = req;

  //const bannerData = await fetchPageData("pages.Banner", "banner");

  const pageStatus = await fetchPage("pages.DashboardPage");

  let pageData;
  if (pageStatus.status === 200) {
    const pageTemp = await pageStatus.json();
    pageData = await pageFilter(pageTemp, "dashboard");
  } 
  

  const userStatus = await fetchNoStore(
    `${process.env.NEXT_PUBLIC_BASE_CMS}/api/user/info`,
    {
      headers: {
        Cookie: `boho_session=${cookies.boho_session}`,
      },
    },
  );

  let userData;
  if (userStatus.status === 200) {
    const userTemp = await userStatus.json();
    userData = await transformIncomingData(userTemp);
    if (userData.onboarding_completed === false) {
      return {
        redirect: {
          permanent: false,
          destination: "/onboarding/profile",
        },
        props: {},
      };
    }
  } else if (
    userStatus.status === 401 ||
    userStatus.status === 403 ||
    userStatus.status === 400
  ) {
    return {
      redirect: {
        permanent: false,
        destination: "/login",
      },
      props: {},
    };
  }

  // 60 seconds * 60 minutes * 2 hours

  let eventData;
  let venueData;
  if (userData) {
    const response = await fetchNoStore(
      `${process.env.NEXT_PUBLIC_BASE_CMS}/api/events/all`,
      {
        headers: {
          Cookie: `boho_session=${cookies.boho_session}`,
        },
      },
    );
    
    if (response.status === 200) {
      const eventTemp = await response.json();
      eventData = await transformIncomingData(eventTemp);
    }
   

    const responseVenue = await fetchNoStore(
      `${process.env.NEXT_PUBLIC_BASE_CMS}/api/venues/all`,
      {
        headers: {
          Cookie: `boho_session=${cookies.boho_session}`,
        },
      },
    );

    if (response.status === 200) {
      const venueTemp = await responseVenue.json();
      venueData = await transformIncomingData(venueTemp);
    }
   
  }

  return {
    props: {
      // testing: null,
      bannerData: null,
      userData: userData || null,
      pageData: pageData[0] || null,
      eventData: eventData || [],
      venueData: venueData || [],
    },
  };
}
